import { useMutation } from "@tanstack/react-query";
import { createModelAPI, deleteModelAPI, updateModelAPI } from "./model.api";
import { handleNetworkError } from "@repo/ui/libs";

const useAddModelMutation = () => {
  return useMutation({
    mutationFn: createModelAPI,
    onError: handleNetworkError,
  });
};

const useUpdateModelMutation = () => {
  return useMutation({
    mutationFn: updateModelAPI,
    onError: handleNetworkError,
  });
};

const useDeleteModelMutation = () => {
  return useMutation({
    mutationFn: deleteModelAPI,
    onError: handleNetworkError,
  });
};

export { useAddModelMutation, useUpdateModelMutation, useDeleteModelMutation };
